// represents the amount of space between comments with 'spread' being slightly
// greater spacing than 'default'
export type CommentSpacing = 'spread' | 'default';

export enum CommentContentType {
  WHITEBOARD = 'WHITEBOARD',
  DATABASE = 'DATABASE',
}
